import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Solutions() {
  const [solutions, setSolutions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/solutions`)
      .then(res => {
        setSolutions(res.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen pt-32 pb-24">
        <div className="max-w-7xl mx-auto px-6 text-center py-24">
          <div className="inline-block w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen pt-32 pb-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-7xl font-black tracking-tighter uppercase mb-6">
            OUR <span className="text-primary">SOLUTIONS</span>
          </h1>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Comprehensive financing and energy solutions tailored to your needs
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {solutions.map((sol) => (
            <div key={sol.id} className="glass p-8 hover:bg-white/5">
              <span className="inline-block px-3 py-1 border border-primary/30 text-primary text-xs font-mono uppercase mb-4">
                {sol.category}
              </span>
              <h3 className="text-2xl font-semibold mb-4">{sol.title}</h3>
              <p className="text-muted-foreground mb-6">{sol.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center glass p-12">
          <h2 className="text-3xl font-bold mb-6 uppercase">
            READY TO GET <span className="text-primary">STARTED?</span>
          </h2>
          <Link
            to="/contact"
            className="inline-flex items-center px-8 py-4 bg-primary text-black font-mono uppercase text-sm font-bold hover:bg-primary/90"
          >
            GET FREE CONSULTATION
            <ArrowRight className="ml-2" size={18} />
          </Link>
        </div>
      </div>
    </div>
  );
}
